import { config } from './config';

export const microservices = {
  sync: config.url.syncUrl,
  contactsNest: config.url.contactsNestUrl,
  edgeNest: config.url.edgeNestUrl,
  auth: config.url.authUrl,
};
